import { getNearestKeyFrames } from 'content-creation-common/utils/transform';

export { getNearestKeyFrames };

import { convertMapToObject } from './object';

export const isAKeyframeNumber = (element, frameNumber) => {
  const { transforms } = element;
  return Object.keys(transforms).map(parseInt).includes(frameNumber);
};

export const getKeyFramesFromTransforms = (transforms) => {
  let prevFrame = null;
  const nextFrame = null;
  const keys = Object.keys(transforms).sort((a, b) => {
    return a - b;
  });
  return keys.map((frameKey, index) => {
    const frame = parseInt(frameKey, 10);
    const transform = transforms[frameKey];

    // TODO(lemieux) make Keyframe model object
    const keyframe = {
      frame,
      nextFrame: parseInt(keys[index + 1] || nextFrame, 10),
      prevFrame,
      setId: transform.setId,
      setOrder: transform.setOrder,
      transform,
    };

    prevFrame = frame;

    return keyframe;
  });
};

export const getKeyFramesFromTransformsMap = (transformsMap) => {
  const transforms = convertMapToObject(transformsMap, (transform) => {
    return transform.getCreativeDocumentTransform().toJSON();
  });
  return getKeyFramesFromTransforms(transforms);
};

export const getKeyFramesInElement = (element) => {
  return getKeyFramesFromTransforms(element.transforms);
};

export const getPanTransformKeyframeForFrame = (transitionKeys, frame) => {
  const { leftKeyFrame, rightKeyFrame } = getNearestKeyFrames(
    transitionKeys,
    frame,
  );
  let nearestFrame = null;
  if (!leftKeyFrame && rightKeyFrame) {
    nearestFrame = rightKeyFrame;
  } else if (!rightKeyFrame && leftKeyFrame) {
    nearestFrame = leftKeyFrame;
  }
  return nearestFrame;
};

export const getNearestKeyFrameIndex = (frameNumber, keyFrames) => {
  let closestKeyFrameIndex = 0;
  let diff = Number.MAX_SAFE_INTEGER;
  for (let i = 0; i < keyFrames.length; i++) {
    const currentKeyFrame = keyFrames[i];
    if (Math.abs(frameNumber - currentKeyFrame) < diff) {
      diff = Math.abs(frameNumber - currentKeyFrame);
      closestKeyFrameIndex = i;
    }
  }
  return closestKeyFrameIndex;
};
